import styled from 'styled-components'
import { Flex } from 'components/Box'

export const CryptoBox = styled(Flex)`
    background: rgba(2, 5, 46, 0.2);
    justify-content: center;
    align-items: center;

    ${({ theme }) => theme.mediaQueries.xs} {
        width: 60px;
        height: 60px;
        border-radius: 12px;

        & img{
            width: 45px;
            height: 45px;
        }
    }
    ${({ theme }) => theme.mediaQueries.sm} {
        width: 90px;
        height: 90px;

        & img{
            width: 60px;
            height: 60px;
        }
    }
    ${({ theme }) => theme.mediaQueries.md} {
        width: 220px;
        height: 220px;
        border-radius: 20px;

        & img{
            width: 160px;
            height: 160px;
        }
    }
`